import { Card, Button } from 'antd';
import { SimulationCancelButton } from './SimulationCancelButton';
import { useStoreState, useStoreActions } from '../../../store';

export interface SimulationWorkflowCardProps {
  onSave: () => void;
  simulationId?: string | null;
  disabled?: boolean;
  title?: string;
  saveText?: string;
  loading?: boolean;
  children: React.ReactNode;
}

export const SimulationWorkflowCard = ({
  simulationId,
  disabled,
  onSave,
  saveText,
  loading,
  children,
}: SimulationWorkflowCardProps) => {
  const navigationStep = useStoreState((state) => state.simulation.activeNavigationStep);
  const setNavigationStep = useStoreActions((actions) => actions.simulation.setActiveNavigationStep);
  const simulationLoading = useStoreState((state) => state.loading.loadingFlags.simulation);
  return (
    <Card
      loading={loading || simulationLoading}
      actions={[
        ...(navigationStep > 0
          ? [<Button onClick={() => setNavigationStep(navigationStep - 1)}>Previous Step</Button>]
          : []),
        <SimulationCancelButton simulationId={simulationId} />,
        <Button disabled={disabled} onClick={onSave}>
          {saveText ? saveText : 'Save & Continue'}
        </Button>,
      ]}
    >
      {children}
    </Card>
  );
};
